
import animate from "./animate"
import focus from ".//fcous"
const install =  (Vue)=> {
    Vue.directive('animate', animate)
    Vue.directive('focus', focus)

}
export default install